import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'

import ALLOW_RIGHT from 'assets/images/map/allow-right.png'
import ALLOW_DOWN from 'assets/images/map/allow-down.png'

import PIN_ICON_STATION_OPEN from 'assets/images/map/map_marker_station_open.png' //스테이션 운영중 - Station_State: 1
import PIN_ICON_STATION_OPEN_SELECT from 'assets/images/map/map_marker_station_open_select.png' //선택된 스테이션 운영중 - Station_State: 1
import PIN_ICON_STATION_STOP from 'assets/images/map/map_marker_station_stop.png' //스테이션 중지 - Station_State: 3
import PIN_ICON_STATION_STOP_SELECT from 'assets/images/map/map_marker_station_stop_select.png' //스테이션 중지 - Station_State: 3
import PIN_ICON_STATION_READY from 'assets/images/map/map_marker_station_ready.png' //스테이션 준비중 - Station_State: 5
import PIN_ICON_STATION_READY_SELECT from 'assets/images/map/map_marker_station_ready_select.png' //선택된 스테이션 준비중 - Station_State: 5
import PIN_ICON_MAINTENANCE from 'assets/images/map/map_marker_maintenance.png' //서비스점 점검중
import PIN_ICON_MAINTENANCE_SELECT from 'assets/images/map/map_marker_maintenance_select.png' //선택된 서비스점 점검중

import PIN_ICON_SERVICE_OPEN from 'assets/images/map/map_marker_service_open.png' //서비스점 운영중
import PIN_ICON_SERVICE_OPEN_SELECT from 'assets/images/map/map_marker_service_open_select.png' //선택된 서비스점 운영중

import './MapMain.scss'
import '../../style/pretendard.scss'

import * as api from 'api'
import * as functions from 'utils/UtilsFunction'
import { API_CODE, URL } from 'utils'

const MapMain = props => {
    const [searchParams] = useSearchParams()
    const name = searchParams.get('name') //알림톡에서만 시리얼 가져올예정

    const isNewPage = props.isNewPage //새창으로 열기 유무
    const { kakao } = window
    const MAIN_TITLE = props.type === 'network' ? '서비스 네트워크' : '배터리 교환 스테이션'

    const [map, setMap] = useState(null)
    const [width, setWidth] = useState(window.innerWidth) //페이지 너비 너비가바뀔때마다 중앙정렬을위해 사용

    const [sido, setSido] = useState() //화면에서 보여줄 선택한 시도
    const [selectSido, setSelectSido] = useState(false) //선택한 시도
    // 시도 리스트박스 위치
    const [sidoboxPosition, setSidoboxPosition] = useState({
        X: 0,
        Y: 0,
    })

    const [gugun, setGugun] = useState('') //화면에서 보여줄 선택한 구군
    const [selectGugun, setSelectGugun] = useState(false)
    const [gugunList, setGugunList] = useState() //눌렀을때 리스트에 보일 구군 리스트
    // 구군 리스트박스 위치
    const [gugunboxPosition, setGugunboxPosition] = useState({
        X: 0,
        Y: 0,
    })

    let sidoSelectBoxRef = useRef(null)
    let localInfoSelectWrapper = useRef(null)
    let sidoRef = useRef(null)
    let gugunRef = useRef(null)

    const [region, setRegion] = useState({}) //스테이션이 있는 지역 리스트

    const [keyword, setKeyword] = useState('') //사용자가 입력한 키워드 (스테이션명)
    const [stationList, setStationList] = useState() //스테이션 검색시 나타나는 리스트
    const [selectedStation, setSelectedStation] = useState({}) //키워드로 검색한 리스트중 선택한 스테이션

    const selectedMarkerRef = useRef(null) // 현재 선택된 마커 참조
    const markersRef = useRef([]) // 화면에 남아있는 모든 마커 보관
    const isInitializedRef = useRef(false)
    const typingTimer = useRef(null)

    const station_list_params = {
        sido: functions.nullCheck(sido),
        gugun: functions.nullCheck(gugun),
        station_name: '',
        row_size: 9999,
        current_page: 1,
    }

    const { data: station_list, isLoading } = useQuery({
        queryKey: ['station_list', sido, gugun],
        queryFn: () =>
            props.type === 'network'
                ? api.apis.get_network_list(station_list_params)
                : api.apis.get_station_list(station_list_params),
        staleTime: 0,
        cacheTime: 0,
        keepPreviousData: false, //
        refetchOnMount: true,
    })

    const { data: station_region } = useQuery({
        queryKey: ['station_region', props.type],
        queryFn: () => (props.type === 'network' ? api.apis.get_district() : api.apis.get_station_region()),
    })

    // 지역 리스트 가져와서 재조합
    useEffect(() => {
        //빈값체크
        if (station_region?.data?.length > 0) {
            const result = {}
            result['전체'] = []

            // 서비스 네트워크인 경우는 전체 시도 리스트를 조회함
            if (props.type === 'network') {
                station_region?.data?.[0]?.firstSelectBox.forEach(item => {
                    const { sido, sidoFullNm } = item

                    const gugunList = [
                        { station_gugun: '전체' },
                        ...(station_region?.data?.[0]?.secondSelectBox[sido] || []).map(g => ({
                            station_gugun: g.gugun,
                        })),
                    ]

                    result[sidoFullNm] = gugunList
                })

                setRegion(result)
                setSido('전체')
            }
            // 스테이션은 스테이션이 있는 지역만 조회
            else {
                const tempGrouped = station_region?.data.reduce((acc, cur) => {
                    const { station_sido, station_gugun, station_count } = cur

                    if (!acc[station_sido]) {
                        acc[station_sido] = []
                    }

                    acc[station_sido].push({ station_gugun, station_count })
                    return acc
                }, {})

                // 2) gugun '전체' 추가 (세종특별자치시 제외)
                Object.keys(tempGrouped).forEach(sido => {
                    if (sido !== '세종특별자치시') {
                        tempGrouped[sido].unshift({
                            station_gugun: '전체',
                            station_count: undefined,
                        })
                    }
                })

                // 3) '전체'를 맨 위에 추가해서 순서 제어
                const grouped = {
                    전체: [],
                    ...tempGrouped, // 나머지 시도 뒤로
                }

                setRegion(grouped)

                setSido('전체')
            }
        }
    }, [station_region])

    //#region [ :: 지도생성 :: ]
    const setUpMap = () => {
        const mapContainer = document.getElementById('service-map')

        const mapOption = {
            center: new kakao.maps.LatLng(36.5, 127.5),
            level: 13,
            maxLevel: 13,
        }

        const kakaoMap = new kakao.maps.Map(mapContainer, mapOption)
        const zoomControl = new kakao.maps.ZoomControl()
        kakaoMap.addControl(zoomControl, kakao.maps.ControlPosition.BOTTOMRIGHT)

        setMap(kakaoMap)
    }

    // 처음 한 번만 지도 생성
    useEffect(() => {
        setUpMap()
    }, [])

    // URL 초기 통통 마커 저장용 ref
    const urlBounceMarkerRef = useRef(null)

    const handleMarkerSelect = (marker, item) => {
        // 이전 마커 복구
        if (selectedMarkerRef.current && selectedMarkerRef.current !== marker) {
            selectedMarkerRef.current.setImage(selectedMarkerRef.current.smallImage)
            selectedMarkerRef.current.setZIndex(1)

            if (selectedMarkerRef.current.bounceInterval) {
                clearInterval(selectedMarkerRef.current.bounceInterval)
                selectedMarkerRef.current.bounceInterval = null
            }
        }

        // 현재 마커의 기존 애니메이션 중지
        if (marker.bounceInterval) {
            clearInterval(marker.bounceInterval)
            marker.bounceInterval = null
        }

        // 이미지 확대 적용
        marker.setImage(marker.bigImage)
        marker.setZIndex(10)
        selectedMarkerRef.current = marker

        // 통통튀기 애니메이션
        let grow = true
        const interval = setInterval(() => {
            const size = grow ? 60 : 55
            const newImg = new kakao.maps.MarkerImage(marker.bigImageSrc, new kakao.maps.Size(size, size))
            marker.setImage(newImg)
            grow = !grow
        }, 300)

        marker.bounceInterval = interval

        setSelectedStation(item)
    }

    useEffect(() => {
        if (!map || functions.isEmpty(station_list?.data)) return

        // 기존 마커 지우기
        if (markersRef.current.length) {
            markersRef.current.forEach(m => {
                m.setMap(null)
                if (m.bounceInterval) clearInterval(m.bounceInterval)
            })
            markersRef.current = []
        }

        let bounds = new kakao.maps.LatLngBounds()

        station_list?.data?.forEach(item => {
            let smallImage
            let bigImage
            let bigImageSrc
            const bigSize = { width: 55, height: 60 }

            // 마커 이미지 셋팅
            if (props.type === 'network') {
                smallImage = new kakao.maps.MarkerImage(PIN_ICON_SERVICE_OPEN, new kakao.maps.Size(40, 40))
                bigImageSrc = PIN_ICON_SERVICE_OPEN_SELECT
                bigImage = new kakao.maps.MarkerImage(bigImageSrc, new kakao.maps.Size(bigSize.width, bigSize.height))
            } else {
                if (item.state === '1') {
                    smallImage = new kakao.maps.MarkerImage(PIN_ICON_STATION_OPEN, new kakao.maps.Size(40, 40))
                    bigImageSrc = PIN_ICON_STATION_OPEN_SELECT
                    bigImage = new kakao.maps.MarkerImage(
                        bigImageSrc,
                        new kakao.maps.Size(bigSize.width, bigSize.height),
                    )
                } else if (item.state === '3') {
                    smallImage = new kakao.maps.MarkerImage(PIN_ICON_STATION_STOP, new kakao.maps.Size(40, 40))
                    bigImageSrc = PIN_ICON_STATION_STOP_SELECT
                    bigImage = new kakao.maps.MarkerImage(
                        bigImageSrc,
                        new kakao.maps.Size(bigSize.width, bigSize.height),
                    )
                } else if (item.state === '4') {
                    smallImage = new kakao.maps.MarkerImage(PIN_ICON_MAINTENANCE, new kakao.maps.Size(40, 40))
                    bigImageSrc = PIN_ICON_MAINTENANCE_SELECT
                    bigImage = new kakao.maps.MarkerImage(
                        bigImageSrc,
                        new kakao.maps.Size(bigSize.width, bigSize.height),
                    )
                } else if (item.state === '5') {
                    smallImage = new kakao.maps.MarkerImage(PIN_ICON_STATION_READY, new kakao.maps.Size(40, 40))
                    bigImageSrc = PIN_ICON_STATION_READY_SELECT
                    bigImage = new kakao.maps.MarkerImage(
                        bigImageSrc,
                        new kakao.maps.Size(bigSize.width, bigSize.height),
                    )
                }
            }

            // 마커 생성
            const marker = new kakao.maps.Marker({
                position: new kakao.maps.LatLng(item.lat, item.lon),
                map,
                image: smallImage,
            })

            // 마커 정보 저장
            marker.smallImage = smallImage
            marker.bigImage = bigImage
            marker.bigImageSrc = bigImageSrc
            marker.bigImageSize = bigSize
            marker.stationId = item.serialNumber

            markersRef.current.push(marker)

            // 👉 1) URL serial 초기 마커 선택 처리
            if (!isInitializedRef.current && item.name === name) {
                const center = new kakao.maps.LatLng(item.lat, item.lon)

                setTimeout(() => {
                    map.setCenter(center)
                    map.setLevel(5)

                    // 초기 선택도 클릭과 동일하게
                    handleMarkerSelect(marker, item)
                }, 300)

                isInitializedRef.current = true
            }

            // 👉 2) 클릭 이벤트
            kakao.maps.event.addListener(marker, 'click', () => {
                handleMarkerSelect(marker, item)
                setTimeout(() => {
                    const center = new kakao.maps.LatLng(item.lat, item.lon)
                    map.setCenter(center)
                    map.setLevel(5)
                }, 300)
            })

            // 바운스에 좌표 저장
            bounds.extend(new kakao.maps.LatLng(item.lat, item.lon))
        })

        // 지도 리사이즈 반영
        map.relayout()

        // 중심 좌표 설정
        let center
        if (!functions.isEmpty(sido) && sido !== '전체') {
            // center = new kakao.maps.LatLng(station_list?.data?.[0]?.lat, station_list?.data?.[0]?.lon)
            // map.setLevel(9)
            // 시도 선택된 경우 bounds 기반 자동 조정
            map.setBounds(bounds, 50)
        } else {
            center = new kakao.maps.LatLng(36.5, 127.5)
            map.setLevel(13)
            map.setCenter(center)
        }

        return () => {
            // cleanup
            markersRef.current.forEach(m => {
                m.setMap(null)
                if (m.bounceInterval) clearInterval(m.bounceInterval)
            })
            markersRef.current = []
            selectedMarkerRef.current = null
        }
    }, [map, station_list?.data, width])

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])
    //#endregion [ :: 지도생성 :: ]

    //#region [ :: 스테이션 검색 :: ]
    const getStationData = async value => {
        try {
            const params = {
                sido: sido,
                gugun: gugun,
                station_name: value,
                row_size: 9999,
                current_page: 1,
            }
            const result = await api.apis.get_station_list(params)

            if (result?.code === API_CODE.SUCCESS) {
                setStationList(result?.data)
                selectSido(false)
                selectGugun(false)
            }
        } catch (e) {
        } finally {
        }
    }

    const onChangeStationSearch = value => {
        setKeyword(value)

        // 3글자 미만이면 API 호출 안 함
        // if (value.length < 3) return

        // 디바운스: 이전 타이머 제거
        if (typingTimer.current) clearTimeout(typingTimer.current)

        typingTimer.current = setTimeout(() => {
            getStationData(value)
        }, 1000) // 1초 후 호출
    }

    // 사용자가 선택한 스테이션
    useEffect(() => {
        if (functions.isEmpty(selectedStation)) return
    }, [selectedStation])
    //#endregion [ :: 스테이션 검색 :: ]

    //#region [ :: 스테이션 검색 리스트 선택 :: ]
    const handleSelectStation = val => {
        markersRef.current.forEach(m => {
            if (m.bounceInterval) {
                clearInterval(m.bounceInterval)
                m.bounceInterval = null
            }
        })

        setSelectedStation(val) //선택된 스테이션 정보
        setStationList() //검색한 스테이션 리스트 숨기기
        setKeyword(val?.name)

        const targetMarker = markersRef.current.find(m => m.stationId === val.serialNumber)

        let smallImage
        let bigImage

        // 운영중
        if (val.state === '1') {
            smallImage = new kakao.maps.MarkerImage(PIN_ICON_STATION_OPEN, new kakao.maps.Size(40, 40))
            bigImage = new kakao.maps.MarkerImage(PIN_ICON_STATION_OPEN_SELECT, new kakao.maps.Size(55, 55))
        }
        // 중지
        else if (val.state === '3') {
            smallImage = new kakao.maps.MarkerImage(PIN_ICON_STATION_STOP, new kakao.maps.Size(40, 40))
            bigImage = new kakao.maps.MarkerImage(PIN_ICON_STATION_STOP_SELECT, new kakao.maps.Size(55, 55))
        }
        // 점검중
        else if (val.state === '4') {
            smallImage = new kakao.maps.MarkerImage(PIN_ICON_MAINTENANCE, new kakao.maps.Size(40, 40))
            bigImage = new kakao.maps.MarkerImage(PIN_ICON_MAINTENANCE_SELECT, new kakao.maps.Size(55, 55))
        }
        // 준비중
        else if (val.state === '5') {
            smallImage = new kakao.maps.MarkerImage(PIN_ICON_STATION_READY, new kakao.maps.Size(40, 40))
            bigImage = new kakao.maps.MarkerImage(PIN_ICON_STATION_READY_SELECT, new kakao.maps.Size(55, 55))
        }

        // 혹시 이전에 선택된 마커가 있으면 작게 만들기
        if (selectedMarkerRef.current && selectedMarkerRef.current !== targetMarker) {
            selectedMarkerRef.current.setImage(smallImage)
        }
        // 선택된 마커 크게 만들기
        targetMarker.setImage(bigImage)
        selectedMarkerRef.current = targetMarker
        targetMarker.setZIndex(10)

        // 5) 지도 중심 이동

        if (!functions.isEmpty(val.lat) && !functions.isEmpty(val.lon)) {
            const movePosition = new kakao.maps.LatLng(val.lat, val.lon)
            map.setCenter(movePosition)
            map.setLevel(3)
        } else {
        }
    }

    useEffect(() => {
        const wrapper = localInfoSelectWrapper.current
        const gugun = gugunRef.current

        if (!wrapper) return //

        if (selectGugun) {
            wrapper.style.marginLeft = gugun.offsetLeft + 'px'
        } else {
            wrapper.style.marginLeft = '0px'
        }
    }, [selectGugun])

    // 시도 버튼 눌렀을때
    const onClickSido = () => {
        setSelectGugun(false)
        setSelectSido(!selectSido)
        if (props.isNewPage) {
            const ref = sidoRef.current.getBoundingClientRect()
            setSidoboxPosition({
                X: ref.left,
                Y: ref.top,
            })
        }
    }

    //구군 버튼 눌렀을때
    const onClickGugun = () => {
        setSelectGugun(!selectGugun)
        setSelectSido(false)

        if (props.isNewPage) {
            const ref = gugunRef.current.getBoundingClientRect()
            setGugunboxPosition({
                X: ref.left,
                Y: ref.top,
            })
        }

        // navigate()
    }

    return (
        <div
            className="service-map-wrapper"
            style={{
                '--margin-top': `${!isNewPage ? '60px' : 0}`,
            }}>
            {/* 새탭으로 열었을때 상단 메뉴 */}
            {isNewPage && (
                <div className="service-map-header">
                    <h2>{MAIN_TITLE} 검색</h2>
                    <div className="service-map-header-sub-title">
                        <p className="sub-title">가까운 {MAIN_TITLE} 위치를 확인해 보세요.</p>
                        <div className="service-map-sido-wrap">
                            <span className="service-map-sido" onClick={onClickSido} ref={sidoRef}>
                                {functions.nullCheck(sido)}
                            </span>
                            {/* 구군 */}
                            {sido !== '전체' && (
                                <>
                                    <img className="service-map-arrow-img" src={ALLOW_RIGHT} alt="오른쪽 화살표" />
                                    <span className="service-map-sido" onClick={onClickGugun} ref={gugunRef}>
                                        {functions.nullCheck(gugun)}
                                    </span>
                                </>
                            )}
                            {/* 스테이션검색 */}ㅔ
                            {!functions.isEmpty(gugun) && gugun !== '전체' && props.type !== 'network' && (
                                <>
                                    <img className="service-map-arrow-img" src={ALLOW_RIGHT} alt="오른쪽 화살표" />
                                    <div className="search-input-wrap">
                                        <input
                                            className="search-station-input"
                                            type="text"
                                            placeholder="스테이션명을 입력해주세요."
                                            value={keyword}
                                            onChange={e => onChangeStationSearch(e.target.value)}
                                        />
                                        <button
                                            className="search-station-list-button"
                                            onClick={() => {
                                                setStationList(station_list?.data)
                                            }}>
                                            <img src={ALLOW_DOWN} alt="리스트보기" />
                                        </button>
                                        <ul className="search-station-list">
                                            {stationList?.length <= 0 ? (
                                                <li>검색결과가 없습니다.</li>
                                            ) : (
                                                stationList?.map((val, idx) => {
                                                    return (
                                                        <li
                                                            key={idx}
                                                            onClick={() => {
                                                                handleSelectStation(val)
                                                            }}>
                                                            {functions.nullCheck(val?.name)}
                                                        </li>
                                                    )
                                                })
                                            )}
                                        </ul>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* 새탭 페이지가 아니면 지도 내에서 시도,구군 선택 */}
            <div className="search-region-wrapper">
                {!isNewPage && (
                    <div className="search-region-wrap">
                        <span className="search-region">
                            <span onClick={onClickSido} ref={sidoRef}>
                                {sido}
                            </span>
                            {!functions.isEmpty(sido) && sido !== '전체' && (
                                <React.Fragment>
                                    <img className="localInfo-allow-img" src={ALLOW_RIGHT} alt="오른쪽 화살표" />
                                    <span onClick={onClickGugun} ref={gugunRef}>
                                        {gugun}
                                    </span>
                                </React.Fragment>
                            )}
                        </span>
                    </div>
                )}
            </div>

            {!isNewPage && (
                <button className="map_open_button">
                    <a href={props.type === 'network' ? URL.MAP.SERVICE_MAP : URL.MAP.MAIN} target="_blank">
                        새창으로 열기
                    </a>
                </button>
            )}
            {/* 시도 리스트 */}
            {selectSido && (
                <div
                    className="service-map-sido-list-wrap position"
                    ref={localInfoSelectWrapper}
                    style={{
                        '--position-right': `${
                            props.isNewPage ? `${sidoboxPosition.X - 15}px` : `${sidoboxPosition.X - 25}px`
                        }`,
                        '--position-top': `${
                            props.isNewPage ? `${sidoboxPosition.Y + 30}px` : `${sidoboxPosition.Y + 60}px`
                        }`,
                    }}>
                    <ul>
                        {Object.keys(region)?.map((val, i) => {
                            return (
                                <li key={val}>
                                    <span
                                        onClick={() => {
                                            setSelectSido(false)
                                            setSido(val)
                                            setGugunList(region[val])
                                            setGugun(region[val]?.[0]?.station_gugun)
                                            setSelectedStation({})
                                            setKeyword('')
                                        }}>
                                        {val}
                                    </span>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            )}

            {/* 구군 리스트 */}
            {selectGugun && (
                <div
                    className="service-map-sido-list-wrap position"
                    style={{
                        '--position-right': `${
                            props.isNewPage ? `${gugunboxPosition.X - 15}px` : `${gugunboxPosition.X + 60}px`
                        }`,
                        '--position-top': `${
                            props.isNewPage ? `${gugunboxPosition.Y + 30}px` : `${gugunboxPosition.Y + 60}px`
                        }`,
                    }}>
                    <ul>
                        {gugunList?.map((val, i) => {
                            return (
                                <li key={val}>
                                    <span
                                        onClick={() => {
                                            setSelectSido(false)
                                            setSelectGugun(false)
                                            setGugun(val?.station_gugun)
                                            setSelectedStation({})
                                            setKeyword('')
                                        }}>
                                        {val?.station_gugun}
                                    </span>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            )}

            {/* 사용자가 선택한 스테이션 정보 */}
            {!functions.isEmpty(selectedStation) && (
                <div className="station-info-wrap">
                    {props.type !== 'network' && (
                        <div className="station-info-img-wrap">
                            <img src={selectedStation?.defaultImgUrl} alt="스테이션 이미지" />
                        </div>
                    )}

                    <div
                        className="station-info-box"
                        style={{
                            '--width': `${props.type === 'network' ? '100%' : 'calc(100% - 115px)'}`,
                        }}>
                        <p className="station-info-title">
                            {functions.nullCheck(selectedStation?.name)}
                            {props.type !== 'network' && (
                                <span>({functions.nullCheck(selectedStation?.stateTypeText)})</span>
                            )}
                        </p>
                        <p className="station-info-address">{`${functions.nullCheck(selectedStation?.address)}`}</p>
                        {props.type !== 'network' && (
                            <p className="station-info-zipcode">({functions.nullCheck(selectedStation?.zipcode)})</p>
                        )}
                        <p className="station-info-tel">{functions.nullCheck(selectedStation?.telNo)}</p>
                    </div>
                </div>
            )}
            {/* 지도 */}
            <div>
                <div
                    id="service-map"
                    style={{
                        '--width': `${isNewPage ? '100%' : 'calc(50% - 1100px)'}`,
                        '--height': `${isNewPage ? 'calc(100vh - 130px)' : '720px'}`,
                    }}
                />
            </div>
        </div>
    )
}

export default MapMain
